import { music24PlanCapabilities, type Music24PlanTier } from 'fym-shared/src/music24/music24Plans';
import type { MessageDescriptor } from 'react-intl';
import { whoMessages as messages } from './whoMessages';

/** The pitches a day of a plan (`outreachPitchesPerDay` of the plan table). */
export function planRate(tier: Music24PlanTier): number {
  return music24PlanCapabilities[tier].outreachPitchesPerDay;
}

/** The four paid plans of the ladder (design outreach-v2 c1). The Plug plan is never offered. */
export const LADDER_TIERS = ['artist', 'pro', 'manager', 'label'] as const;

export const PLAN_NAMES: Record<Music24PlanTier, MessageDescriptor> = {
  free: messages.planFree,
  trial: messages.planTrial,
  artist: messages.planArtist,
  pro: messages.planPro,
  plug: messages.planPro,
  manager: messages.planManager,
  label: messages.planLabel,
};
